export const get = (state) => {
  return state.feed
}

export const getNewItems = (state) => {
  return state.newItems
}
